import { selectors } from 'modules/common';
import { domain } from 'modules/data';

export const getContacts = (
    contacts: domain.QBooksContactPerson[],
    me: selectors.types.ExpandedUser
): domain.QBooksContactPerson[] => {
    return [
        {
            emailAddress: me.userEmail,
            firstName: me.firstName,
            lastName: me.lastName,
            includeInEmails: true,
        },
        ...contacts
            .filter((contact) => !!contact.emailAddress)
            .map((contact) => ({
                ...contact,
                id: contact.emailAddress,
                text: selectors.user.getDisplayName(contact.firstName, contact.lastName, contact.emailAddress),
            })),
    ];
};
